import React from "react";
import { Link } from "react-router-dom";
import { Feather } from "lucide-react";

export const MarketingFooter = () => (
  <footer className="border-t border-border bg-background" data-testid="marketing-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
      <div className="flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
          <Feather className="w-4 h-4 text-primary-foreground" />
        </div>
        <span className="font-display text-xl font-bold">CodexStudio</span>
      </div>
      <nav className="flex flex-wrap items-center gap-x-7 gap-y-2 text-sm text-muted-foreground">
        <Link to="/guide" className="hover:text-foreground transition-colors" data-testid="footer-guide-link">How it works</Link>
        <Link to="/auth" className="hover:text-foreground transition-colors" data-testid="footer-signin-link">Sign in</Link>
        <Link to="/auth" className="hover:text-foreground transition-colors" data-testid="footer-create-link">Create account</Link>
      </nav>
      <p className="text-xs text-muted-foreground font-mono-code">
        EDITORIAL ATELIER · EST. 2026
      </p>
    </div>
  </footer>
);
